<app-poll-resolution-option (selected)="preselectChoice($event)"
  *ngFor="let choice of choices; let i = index"
  [index] = i
  [isMobile]="isMobile"
  [choice]="choice">
</app-poll-resolution-option>
